<template>
  <div class="bg-neutral-300 shadow p-8 flex flex-col rounded">
    <div class="w-full flex justify-center" v-if="loading">
      <Lynx-Spinner size="12"/>
    </div>

    <form
      v-if="alvaraRenovacao"
      @submit.prevent="submitForm"
      class="flex flex-col"
    >
      <Lynx-Title :text="`Renovação de ${alvaraRenovacao.tipo == 1  ?'Alvará Funcionamento' : alvaraRenovacao.tipo == 2 ? 'Alvará bombeiro' : 'Alvará vigilãncia' }: #${alvaraRenovacao.empresa.id}`"/>

      <div class="bg-neutral-100 border border-neutral-400 rounded p-6 mb-6 flex-wrap flex">
        <span class="text-lg font-display border-b border-neutral-400 w-full pb-2 flex mb-4">
          Solicitação
        </span>

        <p v-if="!editar">
        
       Tipo : {{ alvaraRenovacao.tipo == 1  ? "Alvará Funcionamento" : alvaraRenovacao.tipo == 2 ? "Alvará bombeiro" : "Alvará vigilãncia" }}
         <br>
         Descrição: {{ alvaraRenovacao.descricao }}
        </p>
      
        
        
        <label v-if="editar" class="flex flex-col w-96 mb-4">
          <Lynx-Label label="Tipo de Alteração"/>

          <b-select  v-model="alvara_tipo" placeholder="Selecione o tipo de alteração">
            <option :value="1">Alvará Funcionamento</option>
            <option :value="2">Alvará bombeiro</option>
            <option :value="3">Alvará vigilãncia</option>
            <option :value="4">Alvará de meio ambiente</option>
          </b-select>
        </label>
        <label v-if="editar" class="flex flex-col w-full mb-4">
          <Lynx-Label label="Descrição"/>
        <Lynx-Textarea   placeholder="Descrição da renovação do alvara"  v-model="observacao" />
        </label>


        <button v-if="!editar" class="flex items-center justify-center ml-3" @click.prevent="editar = true">
              <b-icon icon="circle-edit-outline"></b-icon>
            </button>
            <button   v-if="editar" class="flex items-center justify-center ml-3" @click.prevent="editar = false">
              <b-icon icon="check"></b-icon>
            </button>
      </div>

     
      <div class="flex justify-between">
        <Lynx-Button @click.native.prevent="confirmPayment()" type="button" text="Pagamento realizado" class="self-start" color="success-base" :loading="loading" :disable="loading"/>

        <Lynx-Button style="color:white" type="submit" text="Salvar" class="self-end" :loading="loading" :disable="loading"/>
      </div>
    </form>

    <b-modal :active.sync="clienteSearchModalOpened">
      <ClienteSearchModal @selected="onClienteSelected" />
    </b-modal>
  </div>
</template>

<script>

import { AlvaraRenovacaoIndex, AlvaraRenovacaoDelete, AlvaraRenovacaoUpdate } from '@/services/requests/alvaraRenovacao'

import { viaCepRequest } from '@/services/requests/viaCep'
import ClienteSearchModal from '@/views/clientes/SearchModal'
import LynxTextarea from "@/components/helpers/Textarea";

export default {
  name: 'EmpresasAlteracaoEditModal',
  components: { ClienteSearchModal ,LynxTextarea},
  props: [ 'alvaraRenovacao' ],
  data() {
    return {
      clienteSearchModalOpened: false,
      contatosEmail: [
        { tipo: 'email', value: '', optin: true, },
      ],
      contatosCelular: [
        { tipo: 'celular', value: '', optin: true, options: { is_whatsapp: true } },
      ],
      form: {
        empresa: {
          ...this.alvaraRenovacao.empresa,
        },
      },
      loading: false,
      editar:false,
      observacao :this.alvaraRenovacao.descricao,
      alvara_tipo:this.alvaraRenovacao.tipo 

    }
  },
  computed: {  },
  mounted() {
    this.fetchSocioAdmministrador()
    this.fetchContatos()
  },
  methods: {
    addSocio() {
      this.clienteSearchModalOpened = true
    },
    onClienteSelected(cliente) {
      this.clienteSearchModalOpened = false

      const clientesIds = this.form.socios.map(socio => socio.id)

      if (clientesIds.includes(cliente.id)) {
        this.$snack.warning('O cliente já foi adicionado como sócio!')
        return
      }

      this.form.socios.push({ ...cliente })

      if (this.form.socios.length == 1) {
        this.form.socio_administrador = cliente.id
      }
    },
    fetchContatos() {
      const emails = this.form.contatos.filter(contato => contato.tipo == 'email')
      const celulares = this.form.contatos.filter(contato => contato.tipo == 'celular')

      if (emails.length) {
        this.contatosEmail = emails
      }

      if (celulares.length) {
        this.contatosCelular = celulares
      }
    },
    addEmail() {
      this.contatosEmail.push({ tipo: 'email', value: '', optin: true, })
    },
    addCelular() {
      this.contatosCelular.push({ tipo: 'celular', value: '', optin: true, options: { is_whatsapp: true } })
    },
    fetchSocioAdmministrador() {
      if (this.alvaraRenovacao.alteracao.socio_administrador) {
        this.form.socio_administrador = this.alvaraRenovacao.alteracao.socio_administrador
        return
      }

      const socio_administrador = this.alvaraRenovacao.alteracao.socios.filter(socio => socio.pivot ? socio.pivot.socio_administrador : '')
      this.form.socio_administrador = socio_administrador.length ? socio_administrador[0].id : null
    },
    fetchCep(cep) {
      if(cep.length != 8) return
      viaCepRequest(cep)
        .then(res => {
          if(res.data.erro) return
          this.form.endereco.logradouro = res.data.logradouro
          this.form.endereco.cidade = res.data.localidade
          this.form.endereco.bairro = res.data.bairro
          this.form.endereco.ibge = res.data.ibge
          this.form.endereco.uf = res.data.uf
        })
    },

    confirmPayment() {

      this.$buefy.dialog.confirm({
        title: 'Confirmação de Pagamento',
        message: 'Confirma o pagamento da renovação?',
        confirmText: 'Confirmar',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          this.loading = true
          AlvaraRenovacaoUpdate(this.alvaraRenovacao.id, {status_id:2})
            .then(() => {
              this.$snack.success('Pagamento confirmado com sucesso!')
            })
            .finally(() => {
              this.loading = false
              this.fetchAlvaraRenovacao()
            })
        }
      })
    },
    submitForm() {
      this.loading = true
this.form.descricao = this.observacao;
this.form.tipo = this.alvara_tipo;

      const data = {
          ...this.form,
      }

      AlvaraRenovacaoUpdate(this.alvaraRenovacao.id, data)
        .then(() => {
          this.$snack.success('Renovação salva com sucesso!')
          this.$emit('edited')
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          const message = errors.map(item => item.map(error => `<li>${error}</li>`).join('')).join('')

          this.$buefy.dialog.alert({
            title: 'Não foi possível solicitar a alteração',
            message: `<ul>${message}</ul>`,
            type: 'is-danger',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        })
        .finally(() => this.loading = false)
    },
    finalizarAlteracao() {
      this.$buefy.dialog.confirm({
        title: 'Finalizar Renovação',
        message: 'Tem certeza que deseja finalizar a alteração?',
        confirmText: 'Finalizar',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          this.loading = true

          FinalizarAlvaraRenovacao(this.alvaraRenovacao.id)
            .then(() => {
              this.$snack.success('Renovação finalizado com sucesso!')
              this.$emit('edited')
            })
            .catch(error => {
              const errors = Object.values(error.response.data.errors)
              const message = errors.map(item => item.map(error => `<li>${error}</li>`).join('')).join('')

              this.$buefy.dialog.alert({
                title: 'Não foi possível solicitar a alteração',
                message: `<ul>${message}</ul>`,
                type: 'is-danger',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            })
            .finally(() => this.loading = false)
        }
      })
    },
  },
}
</script>
